export default __webpack_public_path__ + "static/media/C0005.2c3e9a6c.png";